import React, {useState} from 'react';
import {Form} from 'react-final-form';
import {Row, Col, ButtonToolbar, Button, Spinner} from 'reactstrap';
import {Field} from 'react-final-form';
import MuiButton from '@material-ui/core/Button';
import axios from "axios";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const FormStep1 = ({config, setStep, csvFile, onSelectCsvFile, onclickBack, onclickNext, importHeaders, processing, showImportSettings, onclickImportSettings, csvImportType, organization, program}) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadTemplate = async () => {
    console.log(csvImportType)
    setIsDownloading(true);
    // const response = await axios.get(`organization/${organization.id}/program/${program.id}/import/download-template`);
    axios.get(`organization/${organization.id}/program/${program.id}/importtype/${csvImportType.id}/download-template`,
    {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/octet-stream',
            'Accept': 'application/csv'
        }
    })
    .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${csvImportType.type}-template.csv`); //or any other extension
        document.body.appendChild(link);
        link.click();
        setIsDownloading(false);
    })
    .catch((error) => {
        console.log(error)
        setIsDownloading(false);
    });
    };
  return (
    <div>
      <Field name={config.importFile.name}>
        {({input, meta}) => (
          <div className="form__form-group">
            <div className="form__form-group-field flex-column">
              <div className="flex-row form__form-group-field"> 
                <div className="flex-column">
                    <div className='d-flex'>
                        <div className=''>
                             <h5 className="m-0 mb-2 d-flex align-items-center">
                                <label htmlFor="csvFile" className="mb-0">
                                    Upload File
                                </label>

                                <Tooltip
                                    title="Upload a CSV file. Please make sure the format matches the sample template."
                                    arrow
                                    placement="right"
                                >
                                    <IconButton size="small" style={{ padding: 4, marginLeft: 6 }}>
                                    <InfoOutlinedIcon fontSize="small" style={{ fontSize: 17 }}/>
                                    </IconButton>
                                </Tooltip>
                                </h5>
                            <MuiButton variant="contained" component="label" style={{textTransform: 'inherit', width: '100%'}} className=''>
                                {config.importFile.label}
                                <input
                                hidden
                                type='file'
                                // accept='.csv'
                                id='csvFile'
                                {...input}
                                onChange={(e) => {
                                    onSelectCsvFile(e.target.files[0])
                                }}
                                value={csvFile?.name.file}
                                >
                                </input>
                            </MuiButton>
                        </div>
                        
                        <div >
                            <div className=''>
                                <h5 className="m-0 mb-2 d-flex" style={{ paddingLeft: '90px'}}>
                                    <label
                                        htmlFor="download-sample-import"
                                        className="text-center mb-0"
                                    >
                                        Download Sample Import
                                    </label>

                                    <Tooltip
                                        title="Download a sample CSV file to see the required format and column headers."
                                        arrow
                                        placement="right"
                                    >
                                        <IconButton size="small" style={{  marginLeft: 6 }}>
                                        <InfoOutlinedIcon style={{ fontSize: 17 }} />
                                        </IconButton>
                                    </Tooltip>
                                </h5>
                                <div className="align-items-center d-flex">
                                    <div className='or-sap'>
                                        <h5 className='m-0'>- OR - </h5>
                                    </div>
                                <Button id="download-sample-import" style={{padding: '8px 25px'}} className="bg-primary text-white mb-0" onClick={()=>downloadTemplate()}>Download Import Template</Button>
                                {isDownloading && <p className="text-center">{'Downloading.. please wait..'}</p>}
                                </div>
                            </div>
                        </div>
                </div>
                </div>
                <div className="flex-column" style={{justifyContent: 'end', padding: '0px 10px', display: 'flex'}}>
                    {processing ? (
                        <>
                            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                Processing <Spinner size="sm" className="ms-2 align-middle" />
                            </div>
                        </>
                    ) : (
                        csvFile?.name
                    )}
                </div>
              </div>
              {meta.touched && !csvFile && (
                <span className="form__form-group-error">
                                    {meta.error}
                                </span>
              )}
              <div>&nbsp;</div>
            </div>
          </div>
        )}
      </Field>
      <div className="form__form-group-row flex-row pt-3">
        <Button className="btn btn-outline-primary btn-sm" color="#ffffff" disabled={processing} onClick={onclickBack} style={{}}>Back</Button>

        {showImportSettings && (
          <Button
            className="btn btn-outline-primary btn-sm"
            color="#ffffff"
            disabled={processing}
            onClick={onclickImportSettings}
          >
            Update Import Settings
          </Button>
        )}

        {csvFile && (
            <Button
                className="btn btn-primary btn-sm"
                color="#ffffff"
                disabled={!(csvFile instanceof File) || processing} type="submit"
            >
                {showImportSettings ? 'Import' : 'Upload'}
            </Button>
        )}
      </div>
    </div>
  )
}

export default FormStep1;

